import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { SSRDataProvider } from './contexts/SSRDataContext'

import { inject } from "@vercel/analytics"

// Initialize Vercel Web Analytics
inject()

ReactDOM.hydrateRoot(
    document.getElementById('root')!,
    <React.StrictMode>
        <HelmetProvider>
            <BrowserRouter>
                <SSRDataProvider>
                    <App />
                </SSRDataProvider>
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>
)
